module.exports = "<svg width=\"6\" height=\"6\" viewBox=\"0 0 6 6\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path opacity=\"0.3\" d=\"M5.11133 3.00003L0.444661 5.69433L0.444662 0.305726L5.11133 3.00003Z\" fill=\"white\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./icons/play.svg
// module id = 872
// module chunks = 0